// extracted by mini-css-extract-plugin
module.exports = {"container":"no-results_container___9XPW","phAnimation":"no-results_phAnimation__q4lqx"};